import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import Root from "./root.tsx";
import "./i18n";

// Clean up persist:* slices that are no longer used (M6: pagination/filter
// moved to URL params; order + config reducers removed entirely).
for (const key of ["persist:order", "persist:config"]) {
    if (localStorage.getItem(key) !== null) localStorage.removeItem(key);
}

export const getRootElement = () => document.getElementById("root");

if (getRootElement()) ReactDOM.createRoot(getRootElement() as HTMLElement).render(<Root><App/></Root>);
